import { render, staticRenderFns } from "./EventReportListFieldReadonly.vue?vue&type=template&id=4c0a071c&scoped=true"
import script from "./EventReportListFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./EventReportListFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a071c",
  null
  
)

export default component.exports